<template>
  <client-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processClientForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateClient } from '@/services/client.service'
import clientBlankForm from '@/components/forms/client/ClientBlankForm'

export default {
  name: 'client-edit-form',
  components: { clientBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        client: {
          id: [],
          first_name: [],
          last_name: [],
          middle_name: [],
          phone: [],
          contract_number: [],
          apartment: [],
          rate_plan: [],
          discount: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processClientForm () {
      this.updateClient().then((success) => {
        if (success) {
          this.showMsg('Информация о клиенте была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateClient () {
      return updateClient(this.$attrs.client).then((response) => {
        this.fillErrors(this.errors.client, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.client, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClientEditForm.vue?1040cf95